import React from "react";
import {Button, Divider} from "antd";
type Props={
    item:any
}
const PaymentCard=(props:Props)=>{
    const {item}=props;

    return  <div className="pay-card  mb-2 p-5  bg-gray-50 border-gray-100 border-2 rounded-xl">
        <div className="grid grid-cols-1      md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 w-full gap-4 ">
            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs">عنوان :  </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.title}</span>
            </div>
            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs"> مبلغ : </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}ریال</span>
            </div>

            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs">شناسه قبض   :  </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.bill_id}</span>
            </div>
            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs"> شناسه پرداخت :  </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.pay_id}</span>
            </div>
            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs">  شماره پیگیری  :  </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.trace_number}</span>
            </div>

        </div>
        <Divider/>
        <Button type="ghost" disabled={true}>پرداخت</Button>

    </div>
}
export default PaymentCard;